module.exports = __webpack_public_path__ + "static/media/moon.37cefb65.jpg";